export const WPSET_DEFAULT = 'ch24_hp_directtypein';
